


import RedSection from "@/components/main/core/RedSection";
import GreySection from "@/components/main/core/GreySection";
import BoxPhoto from "@/components/main/core/BoxPhoto";
import CheckBox from "@/components/main/core/CheckBox";
import FormButton from "@/components/main/buttons/FormButton";
import newFeatured from "@/mixins/data"
import ForgotPassForm from "@/components/main/forms/ForgotPassForm";
export default {
  head() {
    const title = 'Forgot your password?';

    return {
      title: title,
      meta: [
        {
          hid: 'robots',
          name: 'robots',
          content: 'noindex'
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
    }
  },
  name: "login",
  layout: 'clientLayout',
  mixins: [newFeatured],
  components: { ForgotPassForm, BoxPhoto, FormButton, GreySection, RedSection, CheckBox },
  data() {
    return {}
  },
  computed: {},
  mounted() {
  },
  methods: {}
}
